import React, { useState, useEffect, useRef } from "react";
import makeStyles from "utils/makeStyles";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";
import moment from "dayjs";
import _ from "lodash";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import { DeployButton, CloseButton } from "../Buttons";
import SettingsIcon from "@mui/icons-material/Settings";
import Chart from "react-google-charts";
import Skeleton from "react-loading-skeleton";
import { useSnackbar } from "notistack";
import "react-loading-skeleton/dist/skeleton.css";
import {
  currencyFormatter,
  dateFormatter,
  getFilterEndDate,
  getFilterStartDateWoUTC,
} from "utils/helpers";

const MegaLineChart = ({
  vaxisTitle,
  ChartTitle,
  startDate,
  endDate,
  selectedFilters,
  salesProfitData,
  salesProfitProductList,
  fetchSalesProfit,
  loader,
  hideSettingIcon,
  defaultProducts,
  defaultProductSet,
  updatedProducts,
  setDefaultProductsSet,
  setUpdatedProducts,
}) => {
  const defProductRef = useRef(null);
  const { enqueueSnackbar } = useSnackbar();
  const [RenderModal, setRenderModal] = useState(false);
  const [def, setDef] = useState(false);
  const [salesProfit, setSalesProfit] = useState([]);
  const [autoOpen, setAutoOpen] = useState(false);

  const [maxValue, setMax] = useState(0);

  const updateDefaultProducts = async (defaults) => {
    let filters = {
      start_date: getFilterStartDateWoUTC(startDate),
      end_date: getFilterEndDate(endDate),
      operator: selectedFilters?.operator?.value,
      area: selectedFilters?.area?.value,
      location: selectedFilters?.location?.value,
    };
    if (selectedFilters?.vm?.[0]?.value !== "all") {
      filters.vending_machines = selectedFilters.vm.map((item) => ({
        vm_id: item.value,
        vm_name: item.label,
      }));
    }
    defaults.filters = filters;
    try {
      await window.axiosIns
        .post("inventory_statistics/sales_default", defaults)
        .then(() => {
          fetchSalesProfit();
          enqueueSnackbar("Default Products updated successfully!");
          handleClose();
        });
    } catch (err) {
      console.log(err);
    }
  };
  const handleOpen = () => {
    setRenderModal(true);
  };
  const handleClose = () => {
    setRenderModal(false);
  };
  const useStyles = makeStyles((theme) => ({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: "#EDEDED",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      borderRadius: "5px",
    },
    chartNoData: {
      background: "#ededed",
      height: "400px",
      margin: "0px 0px 0px 40px",
      borderRadius: "0.25rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    },
  }));
  const getDates = (startDate, endDate) => {
    var dateArray = [];
    var currentDate = moment(startDate);
    var endDate = moment(endDate);
    while (currentDate <= endDate) {
      dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
      currentDate = moment(currentDate).add(1, "days");
    }
    return dateArray;
  };
  const prepareDataSales = (prodList, rawData, startDate, endDate) => {
    const dates = getDates(startDate, endDate);
    dates.forEach((date) => {
      if (!rawData[date]) rawData[date] = [];
    });

    const sortedData = Object.fromEntries(
      Object.entries(rawData).sort(
        ([a], [b]) =>
          moment(a, "YYYY/MM/DD").toDate() - moment(b, "YYYY/MM/DD").toDate()
      )
    );

    const noSalesTooltip = `<div style="padding:5px;color:red;"><strong>No Sales</strong></div>`;

    const tooltipTemplate = (date, label, value) =>
      `<div style="padding:5px;"><strong>${date}</strong><br><span style="color:green"><strong>${label}:</strong> ${currencyFormatter(
        value
      )}</span></div>`;

    const header = [
      "date",
      ...prodList.flatMap((p) => [
        p.name,
        { role: "tooltip", p: { html: true } },
      ]),
    ];

    const result = [header];
    let max = maxValue;

    Object.entries(sortedData).forEach(([date, entries]) => {
      const row = [dateFormatter(date)];

      const productMap = {};
      entries.forEach((entry) => {
        productMap[entry.product_name] = entry;
      });

      prodList.forEach((product) => {
        const entry = productMap[product.name];
        if (entry) {
          const value = ChartTitle === "Revenue" ? entry.sales : entry.profit;
          max = Math.max(
            max,
            ChartTitle === "Revenue" ? entry.sales : entry.profit
          );
          row.push(value);
          row.push(tooltipTemplate(date, ChartTitle, value));
        } else {
          row.push(0);
          row.push(noSalesTooltip);
        }
      });

      result.push(row);
    });

    setMax(max);
    return result;
  };

  useEffect(() => {
    setSalesProfit(
      prepareDataSales(
        salesProfitProductList,
        salesProfitData,
        startDate,
        endDate
      )
    );
  }, [salesProfitProductList]);
  const classes = useStyles();
  const closeOpenMenus = (e) => {
    if (
      defProductRef.current &&
      autoOpen &&
      !defProductRef.current.contains(e.target)
    ) {
      setAutoOpen(false);
    }
  };

  return (
    <>
      {defaultProducts?.length > 0 ? (
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={RenderModal}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            onClick: (event) => event.stopPropagation(),
            timeout: 500,
          }}
        >
          <Fade in={RenderModal}>
            <div
              className={classes.paper}
              style={{ height: "auto", textAlign: "center", width: "400px" }}
              onFocus={(e) => closeOpenMenus(e)}
            >
              <span
                style={{
                  color: "#045298",
                  fontFamily: "Ubuntu",
                  fontWeight: "bold",
                  fontSize: "15px",
                }}
              >
                Set Default Products
              </span>
              <Autocomplete
                ref={defProductRef}
                style={{ marginTop: "10px" }}
                multiple
                open={autoOpen}
                onSelect={() => setAutoOpen(true)}
                id="checkboxes-autocomplete"
                disableCloseOnSelect
                options={defaultProducts}
                getOptionLabel={(option) => option.name}
                value={defaultProductSet}
                filterSelectedOptions
                onChange={(event, values, details, reason) => {
                  setDefaultProductsSet(values);
                }}
                getOptionDisabled={() =>
                  defaultProductSet?.length > 3 ? true : false
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    slotProps={{ input: {
                      ...params.inputProps,
                      maxLength: 4,
                    } }}
                    variant="outlined"
                    label="Select Default Products"
                    placeholder="Products"
                  />
                )}
              />
              <div
                style={{
                  marginTop: "10px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <div
                  style={{
                    marginRight: "8px",
                  }}
                >
                  <CloseButton
                    id="close"
                    label="Close"
                    color="primary"
                    onClick={() => {
                      handleClose();
                      setDefaultProductsSet(updatedProducts);
                    }}
                  />
                </div>
                <div>
                  <DeployButton
                    id="push"
                    label="Save"
                    color="primary"
                    onClick={() => {
                      def ? setDef(false) : setDef(true);

                      const prepare = (products) => {
                        let data = [];
                        if (products !== undefined && products?.length > 0) {
                          products.map((pd) => {
                            data.push(pd.value);
                          });
                        }
                        return data;
                      };
                      setUpdatedProducts(defaultProductSet);
                      updateDefaultProducts({
                        product_ids: prepare(defaultProductSet),
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </Fade>
        </Modal>
      ) : null}

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          height: "400px",
          borderRadius: "15px",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            zIndex: "100",
            position: "absolute",
            marginRight: "-38vw",
            marginTop: "-50px",
          }}
        >
          {!hideSettingIcon && defaultProducts && defaultProducts?.length ? (
            <SettingsIcon
              style={{ marginTop: "5px", cursor: "pointer" }}
              onClick={() => {
                handleOpen();
              }}
              color="primary"
            />
          ) : null}
        </div>
        {loader ? (
          <div
            style={{
              width: "100%",
              margin: "0px 0px 0px 40px",
            }}
          >
            <Skeleton height={400}></Skeleton>
          </div>
        ) : !salesProfitProductList?.length ? (
          <div className={classes.chartNoData}>
            <div>No data for selected filters.</div>{" "}
          </div>
        ) : (
          <Chart
            style={{ width: "100%", borderRadius: "15px", height: "100%" }}
            width={"100%"}
            height={"400px"}
            chartType="LineChart"
            loader={
              <div style={{ width: "90%" }}>
                <Skeleton count={8} />
              </div>
            }
            data={salesProfit}
            options={{
              chartArea: { width: "80%", borderRadius: "15px" },
              borderRadius: "15px",
              colors: ["#01C909", "#4E01C9", "#FEC008", "#DC3444", "#1E85E0"],
              backgroundColor: "#FFFFFF",
              titleTextStyle: {
                color: "#045298",
                fontSize: 15,
                bold: true,
                fontName: "Ubuntu",
              },
              series: {
                1: { curveType: "function" },
              },
              vAxis: {
                title: vaxisTitle,
                viewWindowMode: "explicit",
                viewWindow: {
                  min: 0,
                  // max: maxValue === 0 ? 5 : maxValue,
                },
              },
              hAxis: {
                title: "Timeline",
                textStyle: { fontSize: 12 },
                slantedText: false,
                gridlines: {
                  count: 10,
                },
                maxAlternation: 1,
              },
              legend: {
                position: "top",
                alignment: "center",
              },
              tooltip: {
                isHtml: true,
              },
            }}
            rootProps={{ "data-testid": "2" }}
          />
        )}
      </div>
    </>
  );
};

export default MegaLineChart;
